/**
 * Avatar / initials helpers for audio chat participant cards (CTS-9778).
 */

const GENERIC_AVATAR_MARKERS = [
  'icon_coach_generic',
  'icon_person_generic',
  'icon_coach_generic_white',
]

/**
 * Returns a real photo URL, or null when missing / using a generic placeholder.
 * Generic orange/coach silhouette fallbacks should show initials instead.
 */
export function getRealAvatarUrl(person) {
  const url = person?.bigAvatar || person?.avatar || null
  if (!url || typeof url !== 'string') {
    return null
  }
  if (GENERIC_AVATAR_MARKERS.some((marker) => url.includes(marker))) {
    return null
  }
  return url
}

/**
 * Two-letter initials from displayName / first+last / firstName.
 * @param {Object} person
 * @returns {string}
 */
export function getParticipantInitials(person) {
  const displayName = (person?.displayName || person?.name || '').trim()
  if (displayName) {
    const parts = displayName.split(/\s+/).filter(Boolean)
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
    }
    if (parts[0].length >= 2) {
      return parts[0].slice(0, 2).toUpperCase()
    }
    return `${parts[0][0] || '?'}`.toUpperCase()
  }

  const first = (person?.firstName || '').trim()
  const last = (person?.lastName || '').trim()
  if (first && last) {
    return `${first[0]}${last[0]}`.toUpperCase()
  }
  if (first) {
    return first.slice(0, 2).toUpperCase()
  }

  return '?'
}
